import { Card } from '@/components/ui/Card';
import type { EstimateItemStats } from '../../shared/types/estimate.types';

interface EstimatesTopBarProps {
  stats?: EstimateItemStats;
}

function formatCurrency(value: number) {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
    maximumFractionDigits: 0,
  }).format(value || 0);
}

function formatPercent(value: number) {
  return `${value.toLocaleString('vi-VN', { maximumFractionDigits: 1 })}%`;
}

export function EstimatesTopBar({ stats }: EstimatesTopBarProps) {
  const total = stats?.totalAmount || 0;
  const materialShare = total > 0 ? ((stats?.materialCost || 0) / total) * 100 : 0;
  const laborShare = total > 0 ? ((stats?.laborCost || 0) / total) * 100 : 0;

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      <Card className="flex items-center gap-3 border-slate-200 bg-white p-3 shadow-sm">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-emerald-50 text-emerald-600">
          <i className="ri-money-dollar-circle-line text-xl" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="truncate text-xs text-slate-500">Tổng dự toán</p>
          <p className="mt-0.5 text-base font-medium text-slate-800">{formatCurrency(total)}</p>
        </div>
      </Card>

      <Card className="flex items-center gap-3 border-slate-200 bg-white p-3 shadow-sm">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-blue-50 text-blue-600">
          <i className="ri-list-check-3 text-xl" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="truncate text-xs text-slate-500">Hạng mục bóc tách</p>
          <p className="mt-0.5 text-base font-medium text-slate-800">{stats?.itemCount || 0}</p>
        </div>
      </Card>

      <Card className="flex items-center gap-3 border-slate-200 bg-white p-3 shadow-sm">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-amber-50 text-amber-600">
          <i className="ri-bar-chart-box-line text-xl" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="truncate text-xs text-slate-500">Tỷ trọng vật tư / nhân công</p>
          <p className="mt-0.5 text-base font-medium text-slate-800">
            {formatPercent(materialShare)} / {formatPercent(laborShare)}
          </p>
        </div>
      </Card>

      <Card className="relative flex items-center gap-3 overflow-hidden border-rose-200 bg-rose-50 p-3 shadow-sm">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-rose-100 text-rose-600">
          <i className="ri-alarm-warning-line text-xl" />
        </div>
        <div className="z-10 min-w-0 flex-1">
          <p className="truncate text-xs font-medium text-rose-600">Cảnh báo dữ liệu</p>
          <p className="mt-0.5 text-base font-medium text-rose-700">{stats?.warningCount || 0} hạng mục</p>
        </div>
      </Card>
    </div>
  );
}
